export default {
  'component.tagSelect.expand': '展开',
  'component.tagSelect.collapse': '收起',
  'component.tagSelect.all': '全部',
  'component.deployNotice.expectedEnd': '预计结束',
  'component.scrollToTop.label': '回到顶部',
  'component.couponStockAlert.title': '优惠券已用完 — 结算失败',
  'component.couponStockAlert.member': '会员',
  'component.couponStockAlert.coupon': '优惠券',
  'component.couponStockAlert.remaining': '剩余数量',
  'component.couponStockAlert.products': '结算商品',
  'component.couponStockAlert.orderTotal': '订单金额',
  'component.couponStockAlert.attempts': '尝试 {count} 次',
  'component.couponStockAlert.andMore': '等 {count} 件',
  'component.couponStockAlert.action': '请增加发放数量或结束该优惠券。会员未能完成支付。',
  // 자사몰 상품 피커(OwnMallProductPickerModal) 공용 문구
  'component.productPicker.title': '注册自营商城商品',
  'component.productPicker.confirm': '添加所选商品 ({count})',
  'component.productPicker.searchPlaceholder': '按商品名 / OfferId / UniqueNo 搜索',
  'component.productPicker.loadFailed': '商品列表加载失败。',
  'component.productPicker.noneSelected': '请选择要添加的商品。',
  'component.productPicker.allStores': '全部店铺',
  'component.productPicker.totalProducts': '共 {total} 个',
  'component.productPicker.columns.image': '图片',
  'component.productPicker.columns.title': '商品名',
  'component.productPicker.columns.productNo': '商品编号',
  'component.productPicker.columns.uniqueNo': 'UniqueNo',
  'component.productPicker.columns.salePrice': '售价',
  // 자사몰 상품 상세 팝업(OwnMallProductDetailModal) 공용 문구
  'component.ownMallProductDetail.title': '自营商城商品详情',
  'component.ownMallProductDetail.notFound': '未找到该商品。',
  'component.ownMallProductDetail.loadFailed': '商品信息加载失败。',
  'component.ownMallProductDetail.field.titleKo': '商品名（韩文）',
  'component.ownMallProductDetail.field.titleEn': '商品名（英文）',
  'component.ownMallProductDetail.field.titleZh': '商品名（中文）',
  'component.ownMallProductDetail.field.productNo': '商品编号',
  'component.ownMallProductDetail.field.uniqueNo': 'UniqueNo',
  'component.ownMallProductDetail.field.offerId': 'OfferId',
  'component.ownMallProductDetail.field.companyName': '店铺名',
  'component.ownMallProductDetail.field.salesStatus': '销售状态',
  'component.ownMallProductDetail.field.displayStatus': '展示状态',
  'component.ownMallProductDetail.field.flags': '标记',
  'component.ownMallProductDetail.field.costPrice': '成本价',
  'component.ownMallProductDetail.field.salePrice': '售价',
  'component.ownMallProductDetail.field.tagPrice': '标价',
  'component.ownMallProductDetail.field.marginRate': '毛利率',
  'component.ownMallProductDetail.field.stock': '库存',
  'component.ownMallProductDetail.field.createdAt': '登记日期',
  'component.ownMallProductDetail.status.onSale': '在售',
  'component.ownMallProductDetail.status.offSale': '停售',
  'component.ownMallProductDetail.status.soldOut': '售罄',
  'component.ownMallProductDetail.status.stopped': '停止',
  'component.ownMallProductDetail.status.draft': '草稿',
  'component.ownMallProductDetail.display.visible': '展示',
  'component.ownMallProductDetail.display.hidden': '隐藏',
  'component.ownMallProductDetail.flag.popular': '人气',
  'component.ownMallProductDetail.flag.featured': '推荐',
  'component.ownMallProductDetail.flag.newArrival': '新品',
  'component.ownMallProductDetail.flag.bestSeller': '畅销',
  'component.ownMallProductDetail.sku.title': '各选项价格 · 库存',
  'component.ownMallProductDetail.sku.image': '图片',
  'component.ownMallProductDetail.sku.option': '选项',
  'component.ownMallProductDetail.sku.noOption': '无选项',
  'component.ownMallProductDetail.sku.empty': '暂无已登记的选项。',
  'component.ownMallProductDetail.action.openStorefront': '在自营商城查看',
  'component.ownMallProductDetail.action.edit': '前往编辑页面',
};
